// eslint-disable-next-line no-unused-vars
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./Footer.scss";
import { useLang } from "../../Utility/hooks/useLang";
import Config from "../../env/config";
import { Link } from "react-router-dom";

const Footer = () => {
  // eslint-disable-next-line no-unused-vars
  const { lang, setLang } = useLang();

  // const [lang] = useState(
  //   sessionStorage.getItem("lang") ? sessionStorage.getItem("lang") : "en"
  // );
  // eslint-disable-next-line no-unused-vars
  const { t, i18n } = useTranslation();
  const currentYear = new Date().getFullYear();
  useEffect(() => {
    changeLanguage(lang ? lang : sessionStorage.getItem("lang"));
  }, [lang]);
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  // const isArabicLang = lang === "ar";
  const CDN_URL = Config.CDN_URL;

  return (
    <div className="footerWaraper">
      <div className="cityImgSec"></div>
      <div className="footerMain">
        <div className="footerContainer">
          <div className="footerContactFlx">
            <div className="ftCntRight">
              <div className="mobile-hidden">
                <div className="socialItem">
                  {lang === "ar" ? (
                    <div className="followTxt dirRtl">تابعنا على</div>
                  ) : (
                    <div className="followTxt">FOLLOW US ON</div>
                  )}
                  {/* instagram ICON STARTS HERE */}
                  <a
                    className="socialIconBox"
                    href="https://www.instagram.com/tameen.om/"
                    target="_blank"
                    title="instagram"
                  >
                    <span className="socInc">
                      <img src={`${CDN_URL}instaInc.webp`} alt="instagram"
                        width={29} height={28}
                      />
                    </span>
                    {lang === "ar" ? (
                      <span className="dirRtl">انستغرام</span>
                    ) : (
                      <span>INSTAGRAM</span>
                    )}
                  </a>
                  {/* instagram ICON ENDS HERE */}
                  {/* facebook ICON STARTS HERE */}
                  <a
                    className="socialIconBox"
                    href="https://www.facebook.com/tameen.om.insurance"
                    target="_blank"
                    title="facebook"
                  >
                    <span className="socInc">
                      <img src={`${CDN_URL}fbInc.webp`} alt="facebook"
                        width={29} height={28}
                      />
                    </span>
                    {lang === "ar" ? (
                      <span className="dirRtl">فيسبوك</span>
                    ) : (
                      <span>FACEBOOK</span>
                    )}
                  </a>
                  {/* facebook ICON ENDS HERE */}
                  {/* snapchat ICON STARTS HERE */}
                  <a
                    className="socialIconBox"
                    href="https://www.snapchat.com/add/tameen.om"
                    target="_blank"
                    title="snapchat"
                  >
                    <span className="socInc">
                      <img src={`${CDN_URL}snapchat.webp`} alt="snapchat"
                        width={22} height={22} className="mediaIcon"
                      />
                    </span>
                    {lang === "ar" ? (
                      <span className="dirRtl">سناب شات</span>
                    ) : (
                      <span>SNAPCHAT</span>
                    )}
                  </a>
                  {/* snapchat ICON ENDS HERE */}
                  {/* WHATSAPP ICON STARTS HERE */}
                  <a
                    className="socialIconBox"
                    href="https://wa.me/96872227122"
                    target="_blank"
                    title="whatsapp"
                  >
                    <span className="socInc">
                      <img src={`${CDN_URL}whatIcon.webp`}
                        width={22} height={22}
                        alt="whatsapp" className="mediaIcon"
                      />
                    </span>
                    {lang === "ar" ? (
                      <span className="dirRtl">واتس اب</span>
                    ) : (
                      <span>WHATSAPP</span>
                    )}
                  </a>
                  {/* WHATSAPP ICON ENDS HERE */}
                  {/* Linkedin ICON STARTS HERE */}
                  <a
                    className="socialIconBox"
                    href="https://www.linkedin.com/company/tameen-om"
                    target="_blank"
                    title="linkedin"
                  >
                    <span className="socInc">
                      <img src={`${CDN_URL}linkedInc.webp`} alt="linkedin"
                        width={29} height={28}
                      />
                    </span>
                    {lang === "ar" ? (
                      <span className="dirRtl">لينكدين</span>
                    ) : (
                      <span>LINKEDIN</span>
                    )}
                  </a>
                  {/* Linkedin ICON ENDS HERE */}
                </div>
              </div>
              {/* MOBILE VIEW SOCIAL MEDIA ICONS STARTS HERE */}
              <div className="desktop-hidden">
                <div className="socialItem">
                  <div className="followTxt">
                    {lang === "ar" ? "تابعنا على" : "FOLLOW US ON"}
                  </div>
                  <div className="socialIconFlex">
                    {/* instagram ICON STARTS HERE */}
                    <a
                      className="socialIconBox"
                      href="https://www.instagram.com/tameen.om/"
                      target="_blank"
                      title="instagram"
                    >
                      <span className="socInc">
                        <img src={`${CDN_URL}instaInc.webp`} alt="instagram"
                          width={29} height={28}
                        />
                      </span>
                      {lang === "ar" ? (
                        <span className="dirRtl">انستغرام</span>
                      ) : (
                        <span>INSTAGRAM</span>
                      )}
                    </a>
                    {/* instagram ICON ENDS HERE */}
                    {/* FACEBOOK ICON STARTS HERE */}
                    <a
                      className="socialIconBox"
                      href="https://www.facebook.com/tameen.om.insurance"
                      target="_blank"
                      title="facebook"
                    >
                      <span className="socInc">
                        <img src={`${CDN_URL}fbInc.webp`} alt="facebook"
                          width={29} height={28}
                        />
                      </span>
                      {lang === "ar" ? (
                        <span className="dirRtl">فيسبوك</span>
                      ) : (
                        <span>FACEBOOK</span>
                      )}
                    </a>
                    {/* FACEBOOK ICON ENDS HERE */}
                    {/* SNAPCHAT ICON STARTS HERE */}
                    <a
                      className="socialIconBox"
                      href="https://www.snapchat.com/add/tameen.om"
                      target="_blank"
                      title="snapchat"
                    >
                      <span className="socInc">
                        <img src={`${CDN_URL}snapchat.webp`} alt="snapchat"
                          width={22} height={22} className="mediaIcon"
                        />
                      </span>
                      {lang === "ar" ? (
                        <span className="dirRtl">سناب شات</span>
                      ) : (
                        <span>SNAPCHAT</span>
                      )}
                    </a>
                    {/* SNAPCHAT ICON ENDS HERE */}
                    {/* whatsapp ICON STARTS HERE */}
                    <a
                      className="socialIconBox"
                      href="https://wa.me/96872227122"
                      target="_blank"
                      title="whatsapp"
                    >
                      <span className="socInc">
                        <img src={`${CDN_URL}whatIcon.webp`} alt="whatsapp"
                          width={22} height={22} className="mediaIcon"
                        />
                      </span>
                      {lang === "ar" ? (
                        <span className="dirRtl">واتس اب</span>
                      ) : (
                        <span>WHATSAPP</span>
                      )}
                    </a>
                    {/* whatsapp ICON ENDS HERE */}
                    {/* LINKED IN ICON STARTS HERE */}
                    <a
                      className="socialIconBox"
                      href="https://www.linkedin.com/company/tameen-om"
                      target="_blank"
                      title="linkedin"
                    >
                      <span className="socInc">
                        <img src={`${CDN_URL}linkedInc.webp`} alt="linkedin"
                          width={29} height={28}
                        />
                      </span>
                      {lang === "ar" ? (
                        <span className="dirRtl">لينكدين</span>
                      ) : (
                        <span>LINKEDIN</span>
                      )}
                    </a>
                    {/* LINKED IN ICON ENDS HERE */}
                  </div>
                </div>
              </div>
              {/* MOBILE VIEW SOCIAL MEDIA ICONS ENDS HERE */}
            </div>
          </div>

          {/* QUICK LINKS SECTION STARTS HERE */}
          <div className="footerQuickLinkFlx">
            {lang === "ar" ? (
              <div className="quickLinkTitle dirRtl">روابط سريعة</div>
            ) : (
              <div className="quickLinkTitle">Quick Links</div>
            )}
            <div className="quickLinksItem">
              <div className="linksItem">
                {lang === "ar" ? (
                  <Link to={(lang === "ar" ? "/ar" : "") + "/about-us"} className="dirRtl">
                    نبذة عن تأمين.اوم
                  </Link>
                ) : (
                  <Link to={(lang === "ar" ? "/ar" : "") + "/about-us"}>About Tameen.om</Link>
                )}
                {lang === "ar" ? (
                  <Link to={(lang === "ar" ? "/ar" : "") + "/claims-assistance"} className="dirRtl">
                    المساعدة في المطالبات
                  </Link>
                ) : (
                  <Link to={(lang === "ar" ? "/ar" : "") + "/claims-assistance"}>Claims Assistance</Link>
                )}
                {lang === "ar" ? (
                  <Link to={(lang === "ar" ? "/ar" : "") + "/feedback-complaints"} className="dirRtl">
                    الملاحظات والشكاوي
                  </Link>
                ) : (
                  <Link to={(lang === "ar" ? "/ar" : "") + "/feedback-complaints"}>Feedback and Complaints</Link>
                )}
                {/* {lang === "ar" ? (
                  <a
                    href={`https://storage.tameen.om/tameen/user-manual/customer_onboarding.pdf`}
                    target="blank"
                    className="dirRtl"
                  >
                    دليل المستخدم
                  </a>
                ) : (
                  <a
                    href={`https://storage.tameen.om/tameen/user-manual/customer_onboarding.pdf`}
                    target="blank"
                  >
                    User Manual
                  </a>
                )} */}
              </div>
              <div className="linksItem">
                {lang === "ar" ? (
                  <Link to={(lang === "ar" ? "/ar" : "") + "/corporate-insurance"} className="dirRtl">
                    تأمين الأعمال
                  </Link>
                ) : (
                  <Link to={(lang === "ar" ? "/ar" : "") + "/corporate-insurance"}>Corporate Insurance</Link>
                )}
                {lang === "ar" ? (
                  <Link to={(lang === "ar" ? "/ar" : "") + "/personal-lines-of-insurance"} className="dirRtl">
                    التأمين الشخصي
                  </Link>
                ) : (
                  <Link to={(lang === "ar" ? "/ar" : "") + "/personal-lines-of-insurance"}>Personal lines of Insurance</Link>
                )}
                {lang === "ar" ? (
                  <Link to={(lang === "ar" ? "/ar" : "") + "/product-gallery"} className="dirRtl">
                    أنواع التأمين الشخصي
                  </Link>
                ) : (
                  <Link to={(lang === "ar" ? "/ar" : "") + "/product-gallery"}>Product Gallery</Link>
                )}
              </div>
              <div className="linksItem">
                {lang === "ar" ? (
                  <Link to={(lang === "ar" ? "/ar" : "") + "/faq"} className="dirRtl">
                    الأسئلة الشائعة
                  </Link>
                ) : (
                  <Link to={(lang === "ar" ? "/ar" : "") + "/faq"}>FAQ's</Link>
                )}
                {lang === "ar" ? (
                  <Link to={(lang === "ar" ? "/ar" : "") + "/privacy-policy"} className="dirRtl">
                    سياسة الخصوصية
                  </Link>
                ) : (
                  <Link to={(lang === "ar" ? "/ar" : "") + "/privacy-policy"}>Privacy Policy</Link>
                )}
                {lang === "ar" ? (
                  <Link to={(lang === "ar" ? "/ar" : "") + "/terms-and-conditions"} className="dirRtl">
                    الشروط والأحكام
                  </Link>
                ) : (
                  <Link to={(lang === "ar" ? "/ar" : "") + "/terms-and-conditions"}>Terms & Conditions</Link>
                )}
                {lang === "ar" ? (
                  <Link to={(lang === "ar" ? "/ar" : "") + "/blogs"} className="dirRtl">
                    مدونات
                  </Link>
                ) : (
                  <Link to={(lang === "ar" ? "/ar" : "") + "/blogs"}>Blogs</Link>
                )}
              </div>
              <div className="Whatsapp">
                <div className="mediaTxt">
                  <img src={`${CDN_URL}whatsapp_icon.webp`} alt="WhatsApp" title="WhatsApp"
                    width={21} height={22} loading="lazy"
                  />
                  {lang === "ar" ? "Whatsapp" : "Whatsapp"}
                </div>
                <a className="mobNumber" href="https://wa.me/96872227122" target="_blank">+968 72227122</a>
              </div>

              <div className="ftLogoItem">
                <div className="logoItem">
                  <img src={`${CDN_URL}footer_white_logo.webp`} alt="Tameen" title="Tameen" width={180} height={50} loading="lazy" className="WhiteLogo"
                  />

                </div>
              </div>
            </div>
          </div>
          {/* QUICK LINKS SECTION ENDS HERE */}
          <div className="copyRightsFlx">
            <div className="locationItem">
              {lang === "ar" ?
                <span className="addressItem">
                  شركة ONEIC Tameen ش.م.م (tameen.om)، مبنى المكتب الرئيسي لشركة ONEIC، الطابق الثالث، الخوير الجنوبية، مسقط، سلطنة عُمان.
                </span>
                :
                <span className="addressItem">
                  ONEIC Tameen SPC ( tameen.om ), ONEIC Head Office Building, 3rd Floor, Al Khuwair South, Muscat, Sultanate of Oman
                </span>
              }

              <span className="locMap">
                <span className="mapInc">
                  <i className="fa-solid fa-location-dot"></i>
                </span>
                <a className="mapLin" href="https://maps.app.goo.gl/nS7TGJh5TJ5UGUv39?g_st=aw" target="_blank" rel="noreferrer">
                  {lang === "ar" ?
                    "اذهب الى خرائط جوجل"
                    :
                    "Go to Google Maps"
                  }
                </a>
              </span>

              {/* BACKUP OF PREVIOUS LOCATION CODE */}
              {/* <div style={{ width: '100%', marginTop: '15px' }}>
                <a href="https://share.google/qVfSYCO2913CDCG5c" target="_blank" rel="noreferrer" style={{ display: 'block' }}>
                  <div style={{ pointerEvents: 'none' }}>
                    <iframe
                      src="https://maps.google.com/maps?q=ONEIC%20Head%20Office%20Building,%20Al%20Khuwair%20South,%20Muscat&t=&z=14&ie=UTF8&iwloc=&output=embed"
                      width="100%"
                      height="150"
                      style={{ border: 0, borderRadius: '6px' }}
                      allowFullScreen=""
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      title="Tameen Location Map"
                    ></iframe>
                  </div>
                </a>
              </div> */}
            </div>
            <div className="poweredItem">
              <div className={lang === "ar" ? "PwdArbic" : "PwdEng"}> </div>
            </div>
            {lang === "ar" ? (
              <div className="copyItem dirRtl">
                حقوق النشر © {currentYear} tameen.om. جميع الحقوق محفوظة
              </div>
            ) : (
              <div className="copyItem">
                {/* Copyright &copy; 2024 tameen.om. All Rights Reserved */}
                Copyright &copy; {currentYear} tameen.om. All Rights Reserved
              </div>
            )}
          </div>
        </div>
      </div>
    </div >
  );
};

export default Footer;
